import { useState } from "react";

export default function PopUpMenu({ items, Container }) {

    const [visible, setVisible] = useState(false);

    const Item = ({ label, handleClick }) => {
        return (
            <div className="hover:bg-light-gray cursor-pointer px-3 py-1 text-dark-green" onClick={handleClick}>{label}</div>
        );
    }

    const Menu = () => {
        return (
            <div className={visible ? "overflow-hidden absolute flex flex-col top-2/4 right-2/4 z-50 box-container" : "hidden"} onMouseLeave={()=>setVisible(false)}>
                {items.map((item,index) => <Item key={index} label={item.label} handleClick={item.handleClick} />)}
            </div>
        );

    }

    return (
        <div className="relative">
            <div onClick={() => setVisible(!visible)}>
                <Container />
            </div>
            <Menu />
        </div>

    )

}